import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Feature } from '../../types/check/flags';
import { CheckFlagName } from '../../types/check/types';

interface FlagsState {
	data: Array<Feature> | null | undefined;
}

const initialState: FlagsState = {
	data: []
};

const flagsSlice = createSlice({
	name: 'flags',
	initialState,
	reducers: {
		saveFlags: (state, action: PayloadAction<Array<Feature>>) => {
			state.data = action.payload;
		}
	}
});

export default flagsSlice;

export const flagsActions = flagsSlice.actions;

export const { saveFlags } = flagsActions;

export const selectFlags = (state: RootState) => state.flags.data;

export const selectCheckFlagsWithIDAustria = (state: RootState) => {
	if (!state.flags.data || state.flags.data.length === 0) return undefined;

	return state.flags.data.find((flag) => (flag.name as string) === CheckFlagName.ID_AUSTRIA);
};

export const selectCheckFlagsWithPhotoIdent = (state: RootState) => {
	if (!state.flags.data || state.flags.data.length === 0) return undefined;

	return state.flags.data.find((flag) => (flag.name as string) === CheckFlagName.PHOTO_IDENT);
};

export const selectPhotoIdentRequired = (state: RootState): boolean => {
	const flag = selectCheckFlagsWithPhotoIdent(state) as { settings?: { required?: boolean } } | undefined;
	return Boolean(flag?.settings?.required);
};
